// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__37hvr","empty":"ModalGraph_empty__1mHUW"};